import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'workflow-navigation-create',
    templateUrl: './workflow-navigation-create.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WorkflowNavigationCreateComponent {
}
